import { styled } from '@mui/material/styles';
import { Table } from '@components/Table';

export const StyledTable = styled(Table)({
    '& .MuiTableBody-root .MuiTableCell-root:last-child': {
        width: 150,
    },
});

// INFO: 1 - positive, 0 - neutral, 2 - negative
const KEYWORD_COLOR_MAP = {
    1: '#4CC474',
    0: '#FFCE4D',
    2: '#FF5853',
};

export const SentimentWrapper = styled('div')({
    width: 168,
    display: 'flex',
    height: 8,
});

export const SentimentPiece = styled('div', {
    shouldForwardProp: prop => prop !== 'type' && prop !== 'percentage',
})(({ type, percentage }) => ({
    backgroundColor: KEYWORD_COLOR_MAP[type],
    width: `${percentage}%`,
}));
